import { useNavigate } from "react-router-dom";

// material-ui
import { Container, Box, Button, IconButton, Stack, Typography, AppBar, Toolbar } from "@mui/material";

// material-icons
import LoginIcon from "@mui/icons-material/Login";
import BarChartIcon from "@mui/icons-material/BarChart";
import AddchartIcon from "@mui/icons-material/Addchart";

const GreetingFullPage = (props) => {
    const navigate = useNavigate();

    const handleClickLoginButton = (e) => navigate("/login");

    return (
        <Box>
            <AppBar position="sticky" sx={{ backgroundColor: "whitesmoke" }}>
                <Toolbar>
                    <Container
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box sx={{ display: "flex" }}>
                            <BarChartIcon color="primary" />
                            <Typography color="primary" sx={{ ml: 1, fontWeight: "bold" }}>
                                Strategic Planning
                            </Typography>
                        </Box>
                        <Button startIcon={<LoginIcon />} variant="outlined" onClick={handleClickLoginButton}>
                            Login
                        </Button>
                    </Container>
                </Toolbar>
            </AppBar>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "stretch",
                    height: "600px",
                    backgroundColor: "rgb(19, 47, 76)",
                }}
            >
                <Container>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            height: "100%",
                        }}
                    >
                        <Typography variant="h1" color="primary" sx={{ fontWeight: "bold" }}>
                            DENT PSU
                        </Typography>
                        <Typography variant="h3" color="lightgrey">
                            Strategic Organization Development Dashboard
                        </Typography>

                        <Stack direction="row" spacing={2} sx={{ my: 5 }}>
                            <Button
                                startIcon={<LoginIcon />}
                                variant="outlined"
                                sx={{ color: "lightgrey", width: "250px" }}
                                onClick={handleClickLoginButton}
                            >
                                Login
                            </Button>
                            <Button
                                startIcon={<BarChartIcon />}
                                variant="outlined"
                                sx={{ color: "lightgrey", width: "250px" }}
                            >
                                Open Dashboard
                            </Button>
                        </Stack>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default GreetingFullPage;
